export default function (isActive: Ref<boolean>, wrapper: Ref) {

    function focusTrap(event: KeyboardEvent) {

        if (!isActive.value || event.key !== 'Tab') return

        const modalElement = wrapper.value;

        if (!modalElement) return;

        const focusableElements = modalElement.querySelectorAll(
            'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        ) as NodeListOf<HTMLElement>;

        if (!focusableElements.length) return;

        const firstElement = focusableElements[0] as HTMLElement;
        const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

        if (event.shiftKey && document.activeElement === firstElement) {

            event.preventDefault();
            lastElement.focus();

        } else if (!event.shiftKey && document.activeElement === lastElement) {

            event.preventDefault();
            firstElement.focus();
            
        }
    }

    onMounted(() => {
        document.addEventListener("keydown", focusTrap);
    });

    onUnmounted(() => {
        document.removeEventListener("keydown", focusTrap);
    });
}